import { getUserData, LoginFacebookPayload, LoginGooglePayload, socialLogin } from "@ueni/users-api";
import { AxiosError } from "axios";
import { useCallback, useEffect } from "react";
import { useParams } from "react-router";
import { eventsV2 } from "../../../constants/eventsV2";
import { useQuery } from "../../../hooks";
import { useAfterLogin } from "../../../hooks/useAfterLogin";
import { useErrorHandling } from "../../../hooks/useErrorHandling";
import api from "../../../services/api";
import { sendEvent } from "../../../utils/analytics/sendEvent";
import { getHubUrl } from "../../../utils/hubRoutes";

export const useLoginPage = () => {
  const locale = useParams()["locale"];
  const query = useQuery();
  const { handleApiError } = useErrorHandling();
  const passToken = query.get("pass_token");
  const afterLogin = useAfterLogin();

  const onResolve = useCallback(
    async (payload: LoginGooglePayload | LoginFacebookPayload) => {
      const label = payload.method;
      sendEvent(eventsV2.login.buttonClicked({ label }));
      try {
        const { data } = await socialLogin(api, payload);
        return afterLogin(data, label);
      } catch (e) {
        sendEvent(eventsV2.login.failure({ label }));
        handleApiError(e as AxiosError);
        return;
      }
    },
    [afterLogin]
  );

  const redirectIfAuthorized = useCallback(async () => {
    try {
      const { data } = await getUserData(api);
      return window.location.assign(getHubUrl(data.locale));
    } catch (e) {
      // all good, user is not authorized
    }
  }, []);

  useEffect(() => {
    if (passToken) return;

    // redirectIfAuthorized();
  }, [passToken]);

  return {
    locale,
    onResolve,
  };
};
